/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 后端响应信号管理
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-31 15:34:27
 * @LastEditTime: 2023-03-24 17:19:12
 * @FilePath: /client-h5-v2/src/store/modules/signals.ts
 */
import { setPlaceholder } from '@/common-ts/utils'
// 信号中的对象
interface SignalsItem {
  type: string,
  data: string,
  tip?: null | string
}

export const signals = {
  namespaced: true, // 防止模块命名冲突 设置后调用mutations和action需要'模块名/方法' 例如  dialog/CLEAR_BTN
  state: {
    data: [],
    // 转人工相关
    agentStatus: '',
    agentSuccessStatus: false,
    isAgentCancelBtnClicked: false,
    // 魔方转人工状态监听
    agentStatusChangeMF: '0',
    // input 相关
    placeholder: '',
    lookInput: false,
    disabledInput: false,
    // survey相关
    survey: '',
    surveyType: '',
    // 自动补全
    autoComplete: '',
    // 优惠券条幅显示状态
    couponBannerStatus: false
  },
  getters: {
    data: (state: any) => state.data,
    agentStatus: (state: any) => state.agentStatus,
    agentSuccessStatus: (state: any) => state.agentSuccessStatus,
    isAgentCancelBtnClicked: (state: any) => state.isAgentCancelBtnClicked,
    agentStatusChangeMF: (state: any) => state.agentStatusChangeMF,
    placeholder: (state: any) => state.placeholder,
    lookInput: (state: any) => state.lookInput,
    disabledInput: (state: any) => state.disabledInput,
    survey: (state: any) => state.survey,
    surveyType: (state: any) => state.surveyType,
    autoComplete: (state: any) => state.autoComplete,
    couponBannerStatus: (state: any) => state.couponBannerStatus
  },
  mutations: {
    // 填充信号槽
    PUSH_SIGNALS_DATA (state: { data: [] }, data: []) {
      state.data.push(...data)
    },
    // 清除信号槽
    CLEAR_SIGNALS_DATA (state: { data: [] }) {
      state.data = []
    },
    // 设置转人工状态
    SET_TO_AGENT_STATUS (state: {agentStatus: string}, data: string) {
      state.agentStatus = data
    },
    // 设置转人工成功与否
    SET_AGENT_SUCCESS_STATUS (state: {agentSuccessStatus: boolean}, data:boolean) {
      state.agentSuccessStatus = data
    },
    // 设置转人工取消按钮是否被点击
    SET_AGENT_CANCEL_BTN_CLICKED (state: {isAgentCancelBtnClicked: boolean}, data:boolean) {
      state.isAgentCancelBtnClicked = data
    },
    // 设置魔方转人工状态监听
    SET_AGENT_STATUS_CHANGE_MF (state: {agentStatusChangeMF: string}, data:string) {
      state.agentStatusChangeMF = data
    },
    // 设置输入框提示信息
    SET_PLACEHOLDER_TIPS (state: {placeholder: string}, data: string) {
      state.placeholder = data
    },
    // 设置封锁输入框与否
    SET_LOOK_INPUT (state: {lookInput: boolean}, data:boolean) {
      state.lookInput = data
    },
    // 是否禁止输入框输入
    SET_DISABLED_INPUT (state: {disabledInput: boolean}, data:boolean) {
      state.disabledInput = data
    },
    // 设置survey data
    SET_SURVEY_DATA (state: {survey: string}, data:string) {
      state.survey = data
    },
    // 设置自动补全类型
    SET_AUTO_COMPLETE (state: {autoComplete: string}, data:string) {
      state.autoComplete = data
    },
    // 设置优惠券条幅显示状态
    SET_COUPON_BANNER_STATUS (state: {couponBannerStatus: boolean}, data:boolean) {
      state.couponBannerStatus = data
    }

  },
  actions: {
    signalsFn (store: any, data: any) {
      // 先清除上一次信号槽
      store.commit('CLEAR_SIGNALS_DATA', [])
      // 先清除封锁输入框
      store.commit('SET_DISABLED_INPUT', false)
      store.commit('SET_LOOK_INPUT', '')
      // 再补充当前信号列表
      store.commit('PUSH_SIGNALS_DATA', data)
      // 清除转人工状态
      store.commit('SET_TO_AGENT_STATUS', '')
      // 处理信号槽
      data.map((value: SignalsItem) => {
        // 人工客服
        if (value.type === 'toAgent') {
          store.commit('SET_TO_AGENT_STATUS', value.data)
          return false
        }
        // 输入框提示
        if (value.type === 'placeholder') {
          setPlaceholder(value.data)
          store.commit('SET_PLACEHOLDER_TIPS', value.data)
          return false
        }
        // 输入框封锁
        if (value.type === 'lockInput') {
          store.commit('SET_LOOK_INPUT', value.data)
          store.commit('SET_DISABLED_INPUT', true)
          return false
        }
        // survey
        if (value.type === 'survey') {
          const {surveyContent, surveyData} = JSON.parse(value.data)
          const data = {
            surveyContent: surveyContent,
            surveyData: JSON.parse(surveyData)
          }
          store.dispatch('dialog/messageFn', {
            templateType: JSON.parse(surveyData).templateId,
            payload: data
          }, { root: true })
          store.commit('SET_SURVEY_DATA', data)
          return false
        }
        // 自动补全
        if (value.type === 'autoComplete') {
          store.commit('SET_AUTO_COMPLETE', value.data)
          return false
        }
        // 根据信号打开链接
        if (value.type === 'openLink') {
          window.open(JSON.parse(value.data).link)
        }
        // 是否为action类型
        if (value.type === 'action') {
          // data.url为真则跳转页面
          if (JSON.parse(value.data).url) {
            window.open(JSON.parse(value.data).url)
          }
          // data.actionType=closeWebView则关闭当前页面
          if (JSON.parse(value.data).actionType === 'closeWebView') {
            window.close()
          }
          // data.actionType=closeWebView则关闭当前页面
          if (JSON.parse(value.data).actionType === 'closeFacebook') {
            // 关闭Facebook弹窗 MessengerExtensions webviewRequest.js中引入的js导出的实例
            // eslint-disable-next-line no-undef
            // MessengerExtensions.requestCloseBrowser(function success () {
            //   console.log('success')
            // }, function error (err) {
            //   console.log(err)
            // })
          }
          return false
        }
      })
    }
  }
}

/* 以下信号还未 实现。
"type": "timeOut",
"type": "selfCreateEBIOrderService"
"type": "level"
"type": "createEticket"
"type": "createIframeCard"
"type": "createStepEticket"
"type": "toAgentUserInfoInput"
"type": "popup"
"type": "preSoPopUp"
"type": "selfCreateOderServiceCommitResult",
"type": "selfCreateOderServiceCommitResult",
"type": "action",
"type": "surveyTip",
"type": "preSoPopUpSubmit"
*/
